import React from 'react';
import Lottie from 'lottie-react';
import sendingAnimation from '../assets/sending.json'


const Sending = () => {
  return (
    <div className="sending-container">
      <Lottie animationData={sendingAnimation} loop={true} style={{ width: 200, height: 200 }} />
      <p>Sending...</p>
    </div>
  );
};

export default Sending;